module.exports = __webpack_public_path__ + "img/Aashiv Logo.cfab6629.jpg";